import API from "./interceptor";

// ******************* Create new drilling data entry *******************
export const createDrillingDataEntry = async (entryData) => {
  try {
    const response = await API.post(`/api/drilling-data`, entryData);
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to create drilling data entry"
    );
  }
};

// ******************* Fetch all drilling data entries *******************
export const fetchAllDrillingDataEntries = async (params = {}) => {
  try {
    const response = await API.get(`/api/drilling-data`, { params });
    return response.data;
  } catch (error) {
    throw error?.response?.data?.message || "Failed to fetch drilling data entries";
  }
};

// ******************* Fetch drilling data entry by ID *******************
export const fetchDrillingDataEntryById = async (id) => {
  try {
    const response = await API.get(`/api/drilling-data/${id}`);
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to fetch drilling data entry"
    );
  }
};

// ******************* Update drilling data entry *******************
export const updateDrillingDataEntry = async (id, updateData) => {
  try {
    const response = await API.put(`/api/drilling-data/${id}`, updateData);
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to update drilling data entry"
    );
  }
};

// ******************* Delete drilling data entry *******************
export const deleteDrillingDataEntry = async (id) => {
  try {
    const response = await API.delete(`/api/drilling-data/${id}`);
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to delete drilling data entry"
    );
  }
};

// ******************* Fetch drilling data by vehicle name *******************
export const fetchDrillingDataByVehicle = async (vehicleName, params = {}) => {
  try {
    const response = await API.get(`/api/drilling-data/vehicle/${vehicleName}`, { params });
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to fetch drilling data by vehicle"
    );
  }
};

// ******************* Fetch drilling data by customer type *******************
export const fetchDrillingDataByCustomerType = async (customerType, params = {}) => {
  try {
    const response = await API.get(`/api/drilling-data/customer-type/${customerType}`, { params });
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to fetch drilling data by customer type"
    );
  }
};

// ******************* Fetch drilling data statistics *******************
export const fetchDrillingDataStats = async () => {
  try {
    const response = await API.get(`/api/drilling-data/stats`);
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to fetch drilling data statistics"
    );
  }
};

// ******************* Search drilling data entries *******************
export const searchDrillingDataEntries = async (searchQuery, params = {}) => {
  try {
    const response = await API.get(`/api/drilling-data/search`, { 
      params: { q: searchQuery, ...params } 
    });
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to search drilling data entries"
    );
  }
};

// Vehicle

// ******************* Create new vehicle entry *******************
export const createVehicle = async (vehicleData) => {
  try {
    const response = await API.post(`/api/vehicles`, vehicleData);
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to create vehicle entry"
    );
  }
};

// ******************* Fetch all vehicles *******************
export const fetchAllVehicles = async (params = {}) => {
  try {
    const response = await API.get(`/api/vehicles`, { params });
    return response.data;
  } catch (error) {
    throw error?.response?.data?.message || "Failed to fetch vehicles";
  }
};

// ******************* Fetch vehicle by ID *******************
export const fetchVehicleById = async (id) => {
  try {
    const response = await API.get(`/api/vehicles/${id}`);
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to fetch vehicle"
    );
  }
};

// ******************* Update vehicle *******************
export const updateVehicle = async (id, updateData) => {
  try {
    const response = await API.put(`/api/vehicles/${id}`, updateData);
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to update vehicle"
    );
  }
};

// ******************* Delete vehicle *******************
export const deleteVehicle = async (id) => {
  try {
    const response = await API.delete(`/api/vehicles/${id}`);
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to delete vehicle"
    );
  }
};

// ******************* Fetch vehicles by type *******************
export const fetchVehiclesByType = async (vehicleType, params = {}) => {
  try {
    const response = await API.get(`/api/vehicles/type/${vehicleType}`, { params });
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to fetch vehicles by type"
    );
  }
};

// ******************* Fetch vehicle statistics *******************
export const fetchVehicleStats = async () => {
  try {
    const response = await API.get(`/api/vehicles/stats`);
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to fetch vehicle statistics"
    );
  }
};

// ******************* Search vehicles *******************
export const searchVehicles = async (searchQuery, params = {}) => {
  try {
    const response = await API.get(`/api/vehicles`, { 
      params: { search: searchQuery, ...params } 
    });
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to search vehicles"
    );
  }
};

// ******************* Fetch vehicles by manager *******************
export const fetchVehiclesByManager = async (managerName, params = {}) => {
  try {
    const response = await API.get(`/api/vehicles`, { 
      params: { search: managerName, ...params } 
    });
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to fetch vehicles by manager"
    );
  }
};

// ******************* Bulk operations *******************

// ******************* Create multiple vehicles *******************
export const createMultipleVehicles = async (vehiclesData) => {
  try {
    const response = await API.post(`/api/vehicles/bulk`, { vehicles: vehiclesData });
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to create multiple vehicles"
    );
  }
};

// ******************* Delete multiple vehicles *******************
export const deleteMultipleVehicles = async (vehicleIds) => {
  try {
    const response = await API.delete(`/api/vehicles/bulk`, { data: { ids: vehicleIds } });
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to delete multiple vehicles"
    );
  }
};

// ******************* Export vehicles data *******************
export const exportVehiclesData = async (format = 'csv', filters = {}) => {
  try {
    const response = await API.get(`/api/vehicles/export`, { 
      params: { format, ...filters },
      responseType: 'blob'
    });
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to export vehicles data"
    );
  }
};

// ******************* Check vehicle number availability *******************
export const checkVehicleNumberAvailability = async (vehicleNumber) => {
  try {
    const response = await API.get(`/api/vehicles/check-availability/${vehicleNumber}`);
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to check vehicle number availability"
    );
  }
};

// ******************* Get vehicle types list *******************
export const getVehicleTypes = async () => {
  try {
    const response = await API.get(`/api/vehicles/types`);
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to fetch vehicle types"
    );
  }
};

// ******************* Advanced filtering and sorting *******************
export const fetchVehiclesAdvanced = async (filters = {}) => {
  try {
    const {
      page = 1,
      limit = 10,
      search = '',
      typeOfVehical = '',
      sortBy = 'createdAt',
      sortOrder = 'desc',
      managerName = '',
      dateFrom = '',
      dateTo = ''
    } = filters;

    const params = {
      page,
      limit,
      search,
      typeOfVehical,
      sortBy,
      sortOrder,
      managerName,
      dateFrom,
      dateTo
    };

    // Remove empty parameters
    Object.keys(params).forEach(key => {
      if (params[key] === '' || params[key] === null || params[key] === undefined) {
        delete params[key];
      }
    });

    const response = await API.get(`/api/vehicles`, { params });
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to fetch vehicles with advanced filters"
    );
  }
};


// ******************* Create new agent *******************
export const createAgent = async (agentData) => {
  try {
    const response = await API.post(`/api/agents`, agentData);
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to create agent"
    );
  }
};

// ******************* Fetch all agents *******************
export const fetchAllAgents = async (params = {}) => {
  try {
    const response = await API.get(`/api/agents`, { params });
    return response.data;
  } catch (error) {
    throw error?.response?.data?.message || "Failed to fetch agents";
  }
};

// ******************* Fetch agent by ID *******************
export const fetchAgentById = async (id) => {
  try {
    const response = await API.get(`/api/agents/${id}`);
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to fetch agent"
    );
  }
};

// ******************* Update agent *******************
export const updateAgent = async (id, updateData) => {
  try {
    const response = await API.put(`/api/agents/${id}`, updateData);
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to update agent"
    );
  }
};

// ******************* Delete agent *******************
export const deleteAgent = async (id) => {
  try {
    const response = await API.delete(`/api/agents/${id}`);
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to delete agent"
    );
  }
};


export const addDrillToAgent = async (agentId, drillData) => {
  try {
    const response = await API.post(`/api/agents/${agentId}/drills`, drillData);
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.error || 
      error?.response?.data?.message || 
      "Failed to create bill for agent"
    );
  }
};
// ==================== AGENT BILL MANAGEMENT ====================

// ******************* Add Bill to Agent *******************
export const addBillToAgent = async (agentId, billData) => {
  try {
    const response = await API.post(`/api/agents/${agentId}/bills`, billData);
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.error || 
      error?.response?.data?.message || 
      "Failed to create bill for agent"
    );
  }
};

// ******************* Get all bills for a specific agent *******************
export const getAgentBills = async (agentId) => {
  try {
    const response = await API.get(`/api/agents/${agentId}/bills`);
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.error || 
      error?.response?.data?.message || 
      "Failed to fetch agent bills"
    );
  }
};

// ******************* Update a specific bill for an agent *******************
export const updateAgentBill = async (agentId, billId, updateData) => {
  try {
    const response = await API.put(`/api/agents/${agentId}/bills/${billId}`, updateData);
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.error || 
      error?.response?.data?.message || 
      "Failed to update agent bill"
    );
  }
};

// ******************* Delete a bill from agent *******************
export const deleteAgentBill = async (agentId, billId) => {
  try {
    const response = await API.delete(`/api/agents/${agentId}/bills/${billId}`);
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.error || 
      error?.response?.data?.message || 
      "Failed to delete agent bill"
    );
  }
};


// ******************* Create new bill *******************
export const createBill = async (billData) => {
  try {
    const response = await API.post(`/api/bills`, billData);
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to create bill"
    );
  }
};

// ******************* Fetch all bills *******************
export const fetchAllBills = async (params = {}) => {
  try {
    const response = await API.get(`/api/bills`, { params });
    return response.data;
  } catch (error) {
    throw error?.response?.data?.message || "Failed to fetch bills";
  }
};

// ******************* Fetch bill by ID *******************
export const fetchBillById = async (id) => {
  try {
    const response = await API.get(`/api/bills/${id}`);
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to fetch bill"
    );
  }
};

// ******************* Update bill *******************
export const updateBill = async (id, updateData) => {
  console.log("Updating bill with ID:", id, "with data:", updateData);
  try {
    const response = await API.put(`/api/bills/${id}`, updateData);
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to update bill"
    );
  }
};

// ******************* add payment to bill *******************
export const addPaymentToBill = async (id, paymentData) => {
  console.log(paymentData)
  try {
    const response = await API.put(`/api/bills/${id}/add-payment`, paymentData);
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to update bill"
    );
  }
};

// ******************* Delete bill *******************
export const deleteBill = async (id) => {
  try {
    const response = await API.delete(`/api/bills/${id}`);
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to delete bill"
    );
  }
};

// ******************* Fetch bills by client name *******************
export const fetchBillsByClient = async (clientName, params = {}) => {
  try {
    const response = await API.get(`/api/bills/client/${clientName}`, { params });
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to fetch bills by client"
    );
  }
};

// ******************* Search bills *******************
export const searchBills = async (searchQuery, params = {}) => {
  try {
    const response = await API.get(`/api/bills`, { 
      params: { search: searchQuery, ...params } 
    });
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to search bills"
    );
  }
};

// ******************* Fetch bill statistics *******************
export const fetchBillStats = async () => {
  try {
    const response = await API.get(`/api/bills/stats`);
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to fetch bill statistics"
    );
  }
};

// ******************* Advanced filtering and sorting for bills *******************
export const fetchBillsAdvanced = async (filters = {}) => {
  try {
    const {
      page = 1,
      limit = 10,
      search = '',
      clientName = '',
      sortBy = 'date',
      sortOrder = 'desc',
      dateFrom = '',
      dateTo = '',
      minTotal = '',
      maxTotal = ''
    } = filters;

    const params = {
      page,
      limit,
      search,
      clientName,
      sortBy,
      sortOrder,
      dateFrom,
      dateTo,
      minTotal,
      maxTotal
    };

    // Remove empty parameters
    Object.keys(params).forEach(key => {
      if (params[key] === '' || params[key] === null || params[key] === undefined) {
        delete params[key];
      }
    });

    const response = await API.get(`/api/bills`, { params });
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to fetch bills with advanced filters"
    );
  }
};

// ******************* Bulk operations for bills *******************

// ******************* Create multiple bills *******************
export const createMultipleBills = async (billsData) => {
  try {
    const response = await API.post(`/api/bills/bulk`, { bills: billsData });
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to create multiple bills"
    );
  }
};

// ******************* Delete multiple bills *******************
export const deleteMultipleBills = async (billIds) => {
  try {
    const response = await API.delete(`/api/bills/bulk`, { data: { ids: billIds } });
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to delete multiple bills"
    );
  }
};

// ******************* Export bills data *******************
export const exportBillsData = async (format = 'csv', filters = {}) => {
  try {
    const response = await API.get(`/api/bills/export`, { 
      params: { format, ...filters },
      responseType: 'blob'
    });
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to export bills data"
    );
  }
};

// ******************* Get bills by date range *******************
export const fetchBillsByDateRange = async (startDate, endDate, params = {}) => {
  try {
    const response = await API.get(`/api/bills`, { 
      params: { 
        dateFrom: startDate, 
        dateTo: endDate, 
        ...params 
      } 
    });
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to fetch bills by date range"
    );
  }
};

// ******************* Get client list from bills *******************
export const fetchClientList = async () => {
  try {
    const response = await API.get(`/api/bills/clients`);
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to fetch client list"
    );
  }
};

// ******************* Get monthly revenue *******************
export const fetchMonthlyRevenue = async (year, month) => {
  try {
    const response = await API.get(`/api/bills/revenue/monthly`, {
      params: { year, month }
    });
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to fetch monthly revenue"
    );
  }
};

// ******************* Get yearly revenue *******************
export const fetchYearlyRevenue = async (year) => {
  try {
    const response = await API.get(`/api/bills/revenue/yearly`, {
      params: { year }
    });
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to fetch yearly revenue"
    );
  }
};

// ******************* Get top clients by revenue *******************
export const fetchTopClientsByRevenue = async (limit = 10) => {
  try {
    const response = await API.get(`/api/bills/clients/top-revenue`, {
      params: { limit }
    });
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to fetch top clients by revenue"
    );
  }
};

// ******************* Duplicate bill *******************
export const duplicateBill = async (id) => {
  try {
    const response = await API.post(`/api/bills/${id}/duplicate`);
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to duplicate bill"
    );
  }
};


// ==================== PAYMENT MANAGEMENT ====================

// ******************* Create new payment *******************
export const createPayment = async (paymentData) => {
  try {
    const response = await API.post(`/api/payment`, paymentData);
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to create payment"
    );
  }
};

// ******************* Fetch all payments *******************
export const fetchAllPayments = async (params = {}) => {
  try {
    const response = await API.get(`/api/payment`, { params });
    return response.data;
  } catch (error) {
    throw error?.response?.data?.message || "Failed to fetch payments";
  }
};

// ******************* Fetch payment by ID *******************
export const fetchPaymentById = async (id) => {
  try {
    const response = await API.get(`/api/payment/${id}`);
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to fetch payment"
    );
  }
};

// ******************* Update payment *******************
export const updatePayment = async (id, updateData) => {
  try {
    const response = await API.put(`/api/payment/${id}`, updateData);
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to update payment"
    );
  }
};

// ******************* Delete payment *******************
export const deletePayment = async (id) => {
  try {
    const response = await API.delete(`/api/payment/${id}`);
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to delete payment"
    );
  }
};

// ******************* Fetch payments by bill ID *******************
export const fetchPaymentsByBillId = async (billId) => {
  try {
    const response = await API.get(`/api/payment/bill/${billId}`);
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to fetch payments by bill"
    );
  }
};

// ******************* Fetch payment statistics *******************
export const fetchPaymentStats = async (params = {}) => {
  try {
    const response = await API.get(`/api/payment/stats`, { params });
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to fetch payment statistics"
    );
  }
};

// ******************* Fetch outstanding bills *******************
export const fetchOutstandingBills = async () => {
  try {
    const response = await API.get(`/api/payment/outstanding`);
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to fetch outstanding bills"
    );
  }
};

// ******************* Advanced filtering and sorting for payments *******************
export const fetchPaymentsAdvanced = async (filters = {}) => {
  try {
    const {
      page = 1,
      limit = 10,
      billId = '',
      paymentMethod = '',
      startDate = '',
      endDate = '',
      sortBy = 'paymentDate',
      sortOrder = 'desc'
    } = filters;

    const params = {
      page,
      limit,
      billId,
      paymentMethod,
      startDate,
      endDate,
      sortBy,
      sortOrder
    };

    // Remove empty parameters
    Object.keys(params).forEach(key => {
      if (params[key] === '' || params[key] === null || params[key] === undefined) {
        delete params[key];
      }
    });

    const response = await API.get(`/api/payment`, { params });
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to fetch payments with advanced filters"
    );
  }
};

// ******************* Fetch payments by payment method *******************
export const fetchPaymentsByMethod = async (paymentMethod, params = {}) => {
  try {
    const response = await API.get(`/api/payment`, { 
      params: { paymentMethod, ...params } 
    });
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to fetch payments by method"
    );
  }
};

// ******************* Fetch payments by date range *******************
export const fetchPaymentsByDateRange = async (startDate, endDate, params = {}) => {
  try {
    const response = await API.get(`/api/payment`, { 
      params: { 
        startDate, 
        endDate, 
        ...params 
      } 
    });
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message || "Failed to fetch payments by date range"
    );
  }
};
